import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { removePreset } from "../redux/locationsSelectorSagas";
import { MainModal } from "../../../../components/modal/MainModal";

export const Delete = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const name = useSelector((state) => state.locations.currentPreset.name);

  const close = (e) => {
    e && e.preventDefault();
    onClose();
  };

  const deletePreset = (e) => {
    e.preventDefault();
    dispatch(removePreset());
    close();
  };

  return (
    <MainModal
      parentSelector=".location-selector"
      isOpen={isOpen}
      onClose={close}
      headerText="Delete"
      headerCloseHandler={close}
      height="auto"
      width={300}
      primaryButtonText="Delete"
      primaryBtnHandler={deletePreset}
      primaryButtonClass="critical"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={close}
      secondaryBtnClass="secondary"
      containerClassName="dialog"
      isAdminPanel={false}
    >
      Are you sure you want to delete this preset <span className="preset-name">“{name}”</span>?
    </MainModal>
  );
};
